module.exports = __webpack_public_path__ + "img/link.8dbe06c4.svg";